import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCSzConhYVW4dRUpye2k1FeB2SWXS-6jeQ',
  authDomain: 'sede-zona-galatea.firebaseapp.com',
  projectId: 'sede-zona-galatea',
  storageBucket: 'sede-zona-galatea.firebasestorage.app',
  messagingSenderId: '556588540969',
  appId: '1:556588540969:web:39a872b615efb2dd0ae838',
  measurementId: 'G-DQ1GKF20D7',
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

isSupported().then((supported) => {
  if (supported) {
    getAnalytics(app);
  }
});
